import { type ClientAppConfig, BasketBubbleController } from '@ori/basket-bubble-lib';
import { type FC } from 'react';

export const App: FC<ClientAppConfig> = (configuration) => <BasketBubbleController {...configuration} />;
